/* eslint no-param-reassign: ["error", { "props": false }] */
import { isEmpty, sortBy } from 'lodash';


export function findExpandedKeys(data, selectedId, parentKey, res = []) {
  const selected = data.find(sec => sec.id === selectedId);
  if (selected) {
    res.push(selectedId);
    if (selected[parentKey] !== 'null') {
      findExpandedKeys(data, selected[parentKey], parentKey, res);
    }
  }
  return res;
}

export function updateTreeData(data, selectedId, parentKey, res = []) {
  const expandedKeys = findExpandedKeys(data, selectedId, parentKey, res);
  return data.map(item => ({ ...item, isExpanded: expandedKeys.includes(item.id) }));
}

export function unflattenEntities(entities, idKey, parentIdKey, parent = { [idKey]: 'null' }, tree = []) {
  let currentTree = tree;
  let children = entities.filter(entity => entity[parentIdKey] === parent[idKey]);
  children = sortBy(children, 'order');
  if (!isEmpty(children)) {
    if (parent[idKey] === 'null') {
      currentTree = children;
    } else {
      parent.children = children;
    }
    children.map(child => unflattenEntities(entities, idKey, parentIdKey, child));
  }
  return currentTree;
}



// WEBPACK FOOTER //
// ./src/shared/components/Tree/treeUtils.js